import { render } from "./TemplateFileUploaderComponent.vue?vue&type=template&id=d34289f8"
import script from "./TemplateFileUploaderComponent.vue?vue&type=script&lang=js"
export * from "./TemplateFileUploaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__